import React, { Component } from 'react'
import get from 'lodash/get'
import numeral from 'numeral'
import Parser from 'html-react-parser';

import Plot from 'react-plotly.js';

import Tooltip from "react-simple-tooltip"

class CompletitudCalidadGeneral extends Component {

  constructor(props){
    super(props)
    this.state = {
      dataset : null,
      isPending : true,
      ymargin : 100,
      tooltip : {
        show : false,
        content : '',
        position : [0,0]
      },
      revision : 0,
    }
    this.typeProps = {
      color : {
        completitud: '#66C5CB',
        calidad: '#668CCB',
        validado: '#00c172',
        enUso: '#f5b245',
        rechazado: '#ff4e41',
        noRevisado: '#cccccc',
      },
      title : {
        'completitud' : 'Completitud',
        'calidad' : 'Calidad',
      }
    }
  }

  componentDidMount(){
    console.log(this.props.dataset);
    if(!this.props.dataset.isPending && this.props.dataset.data){
      const {type} = this.props
      const data = this.props.dataset.data
      this.setChartData(type, data)
    }

    this.setState({ isPending: this.props.isPending })
  }

  componentWillReceiveProps(nextProps) {
    console.log(this.props.dataset);
    if(this.props.dataset.isPending != nextProps.dataset.isPending &&
    !nextProps.dataset.isPending && nextProps.dataset.data){

      const {type} = this.props
      const data = nextProps.dataset.data
      this.setChartData(type, data)

    }
  }

  setChartData(type, data){
    let barData = {
      x : [],
      y : [],
      text : []
    }

    if(type == 'completitud'){
      barData = {
        y : [
          'Datos a informar',
          'Datos informados',
          'Datos no informados'
        ],
        x : [
          data.datos_a_informar,
          data.datos_informados,
          data.datos_no_informados,
        ],
        text : [
          numeral(data.datos_a_informar).format('0,0'),
          numeral(data.datos_informados).format('0,0'),
          numeral(data.datos_no_informados).format('0,0'),
        ]
      }
    } else if (type == 'calidad') {
      const pValidados = numeral(data.datos_validados/(data.datos_validados + data.datos_en_uso + data.datos_rechazados + data.datos_no_revisados)).format('0.00%')
      const pEnUso = numeral(data.datos_en_uso/(data.datos_validados + data.datos_en_uso + data.datos_rechazados + data.datos_no_revisados)).format('0.00%')
      const pRechazados = numeral(data.datos_rechazados/(data.datos_validados + data.datos_en_uso + data.datos_rechazados + data.datos_no_revisados)).format('0.00%')
      const pNoRevisados = numeral(data.datos_no_revisados/(data.datos_validados + data.datos_en_uso + data.datos_rechazados + data.datos_no_revisados)).format('0.00%')
      barData = {
        y : [
          'Datos Informados',
          'Validados',
          'En Uso',
          'Rechazados',
          'Sin anexos para validación'
        ],
        x : [
          data.datos_informados,
          data.datos_validados,
          data.datos_en_uso,
          data.datos_rechazados,
          data.datos_no_revisados,
        ],
        text : [
          `${numeral(data.datos_informados).format('0,0')}<br>(100%)`,
          `${numeral(data.datos_validados).format('0,0')}<br>(${pValidados})`,
          `${numeral(data.datos_en_uso).format('0,0')}<br>(${pEnUso})`,
          `${numeral(data.datos_rechazados).format('0,0')}<br>(${pRechazados})`,
          `${numeral(data.datos_no_revisados).format('0,0')}<br>(${pNoRevisados})`,
        ]
      }
    }

    let longestLabel = barData.y.reduce((a, b) => a.length > b.length ? a : b, '');
    let letterWidth = 6
    let ymargin = longestLabel.length * letterWidth

    this.setState({
      dataset : {
        barData : barData,
      },
      isPending : false,
      ymargin : ymargin,
    })
  }

  plotHover(e){
    const {type} = this.props
    let tooltip = this.state.tooltip
    tooltip.show = true
    tooltip.position = [e.event.pageX - e.event.movementX,e.event.pageY]
    tooltip.content = <div>
        <b>{e.points[0].y}</b><hr/>
        <span>{Parser(e.points[0].text)}</span>
      </div>
    this.setState({tooltip})
  }

  plotUnhover(){
    let tooltip = this.state.tooltip
    tooltip.show = false
    this.setState({tooltip})
  }

  render(){

    const { type } = this.props
    const { dataset, isPending, ymargin, rmargin } = this.state

    const { color, title } = this.typeProps
    const barColor = type === 'calidad'
      ? [
        color['calidad'],
        color['validado'],
        color['enUso'],
        color['rechazado'],
        color['noRevisado']
      ]
      : color['completitud']

    const totalCount = numeral(get(this.props.dataset, 'data.datos_informados', 0)).format('0,0')
    const plotTitle = type === 'calidad'
      ? `Calidad General`
      : "Completitud General"

      if(type == 'completitud'){
      return (
        <div>
          {(dataset && !isPending) ?
            <Plot
              divId={`${type}-general-chart`}
              style={{width : '100%', minHeight : 450}}
              data={[{
                type: 'bar',
                x: dataset.barData.x,
                y: ['Datos a informar',
                'Datos informados',
                'Datos no informados'
              ],
                text: dataset.barData.text,
                textposition: 'outside',
                hoverinfo: 'none',
                orientation: 'h',
                cliponaxis: false,
                marker : {
                  color : barColor
                }
              }]}
              layout={{
                title: plotTitle,
                titlefont: {
                  family : 'DINRegular',
                  size: 26,
                },
                plot_bgcolor: 'transparent',
                paper_bgcolor:"transparent",
                font : {
                    color : '#000'
                },
                xaxis: {
                  showgrid: false,
                  linecolor: '#97979C',
                  rangemode: "nonnegative",
                  tickformat : ",.2r",
                  tickfont : {
                    size : 10
                  },
                  fixedrange: true
                },
                yaxis : {
                  showgrid: false,
                  linecolor: '#97979C',
                  tickfont : {
                    size : 10
                  },
                  autorange : "reversed",
                  fixedrange: true
                },
                margin:{
                  l: ymargin,
                },
              }}
              config={{
                displayModeBar: false,
                responsive: true
              }}
              onHover={(e) => this.plotHover(e)}
              onUnhover={() => this.plotUnhover()}
            />
            : <div>cargando...</div>
          }
  
          {this.state.tooltip.show && (
            <Tooltip
              className="simple-tooltip"
              background="#fff"
              border="#ccc"
              color="#000"
              radius={3}
              fontSize='12px'
              fixed={true}
              style={{
                width: 'auto',
                position: "absolute",
                left: this.state.tooltip.position[0],
                top: this.state.tooltip.position[1],
              }}
              content={this.state.tooltip.content}
            />
          )}
  
        </div>
      )
    }else{
            

    return (
      <div>
        {(dataset && !isPending) ?
          <Plot
            divId={`${type}-general-chart`}
            style={{width : '100%', minHeight : 450}}
            data={[{
              type: 'bar',
              x: dataset.barData.x,
              y: dataset.barData.y,
              text: dataset.barData.text,
              textposition: 'outside',
              hoverinfo: 'none',
              orientation: 'h',
              cliponaxis: false,
              marker : {
                color : barColor
              }
            }]}
            layout={{
              title: plotTitle,
              titlefont: {
                family : 'DINRegular',
                size: 26,
              },
              plot_bgcolor: 'transparent',
              paper_bgcolor:"transparent",
              font : {
                  color : '#000'
              },
              xaxis: {
                showgrid: false,
                linecolor: '#97979C',
                rangemode: "nonnegative",
                tickformat : ",.2r",
                tickfont : {
                  size : 10
                },
                fixedrange: true
              },
              yaxis : {
                showgrid: false,
                linecolor: '#97979C',
                tickfont : {
                  size : 10
                },
                autorange : "reversed",
                fixedrange: true
              },
              margin:{
                l: ymargin,
              },
            }}
            config={{
              displayModeBar: false,
              responsive: true
            }}
            onHover={(e) => this.plotHover(e)}
            onUnhover={() => this.plotUnhover()}
          />
          : <div>cargando...</div>
        }

        {this.state.tooltip.show && (
          <Tooltip
            className="simple-tooltip"
            background="#fff"
            border="#ccc"
            color="#333"
            radius={3}
            fontSize='12px'
            fixed={true}
            style={{
              width: 'auto',
              position: "absolute",
              left: this.state.tooltip.position[0],
              top: this.state.tooltip.position[1],
            }}
            content={this.state.tooltip.content}
          />
        )}

      </div>
    )
  }
}
}

export default CompletitudCalidadGeneral
